<template>
  <div
    :class="{ 'h5-recommend-course': isH5, 'pc-recommend-course': !isH5 }"
    class="recommend-course"
  >
    <!-- <p class="content-title">{{ moduleInfo.module_title }}</p> -->
    <!-- <p class="sub-title">{{ moduleInfo.module_sub_title }}</p> -->
    <div v-if="moduleInfo.content_list && moduleInfo.content_list.length">
      <div
        :class="{ 'double-column': moduleInfo.content_style === 3 }"
        class="list-wrap"
      >
        <CourseCardOrg
          v-for="item in moduleInfo.content_list.slice(0, showLength)"
          :key="item.id"
          :type="moduleInfo.content_style === 3 ? 'small' : 'big'"
          :courseInfo="item"
        />
      </div>
      <!-- 查看更多 -->
      <div v-if="moduleInfo.content_list.length > pageSize" class="show-more">
        <p v-if="showLength === moduleInfo.content_list.length">没有更多了~</p>
        <p v-else @click="showMore" class="have-more">
          查看更多<i class="el-icon-arrow-down"></i>
        </p>
      </div>
    </div>
    <el-empty
      v-else
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
  </div>
</template>

<script>
import { getCourseList } from "@saas/service-api/src/course";
import { CourseCardOrg, isH5 } from "@saas/components/src";
export default {
  props: {
    moduleInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      content_style: {
        2: "单列",
        3: "双列",
      },
      isH5: isH5(),
      pageSize: 10, //最多展示10条
      showLength: 10,
    };
  },
  methods: {
    showMore() {
      this.showLength = this.moduleInfo.content_list.length;
    },
  },
  components: {
    CourseCardOrg,
  },
  watch: {
    moduleInfo: {
      handler: function (newVal) {
        // 获取课程详情
        let course_id = [];
        if (newVal.content_list && newVal.content_list.length) {
          newVal.content_list.forEach((item) => {
            course_id.push(item.id);
          });
        }
        if (course_id.length) {
          getCourseList({ course_id: course_id.join(",") }).then((res) => {
            if (res.code === 1) {
              // 排序
              newVal.content_list = (res?.data?.list || []).sort((a, b) => {
                return course_id.indexOf(a.id) - course_id.indexOf(b.id);
              });
            }
          });
        }
      },
      immediate: true, // 设置为true，以便在初次渲染时执行handler
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-recommend-course {
  // .content-title {
  //   margin-bottom: 8px;
  // }
  // .sub-title {
  //   font-size: 16px;
  //   color: $chiral-light-text-color;
  //   line-height: 23px;
  //   margin-bottom: 24px;
  // }
  .show-more {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 12px;
    color: #515350;
    line-height: 17px;
    .have-more {
      color: #00c89d;
      padding: 0 5px;
      cursor: pointer;
    }
    .have-more i {
      font-size: 12px;
      margin-left: 3px;
    }
  }

  .double-column {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    & > div:nth-last-child(2) {
      margin-bottom: 0;
    }
  }
  .list-wrap > div:last-child {
    margin-bottom: 0;
  }
}

.h5-recommend-course {
  // .content-title {
  //   margin-bottom: 0.11rem;
  // }
  // .sub-title {
  //   font-size: 0.35rem;
  //   line-height: 0.48rem;
  //   color: $chiral-light-text-color;
  //   margin-bottom: 0.43rem;
  // }
  .show-more {
    width: 100%;
    display: flex;
    justify-content: center;
    color: #515350;
    font-weight: 400;
    font-size: 0.32rem;
    line-height: 0.44rem;
    margin-top: 0.21rem;
    .have-more {
      color: #00c89d;
      padding: 0 5px;
      cursor: pointer;
    }
    .have-more i {
      font-size: 0.29rem;
      margin-left: 0.08rem;
    }
  }
  .double-column {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    & > div:nth-last-child(2) {
      margin-bottom: 0;
    }
  }
  .list-wrap > div:last-child {
    margin-bottom: 0;
  }
}
</style>
